import { FC } from "react";

export const MoneyIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="attach_money_33dp_E8EAED_FILL0_wght600_GRAD-25_opsz24 1">
      <path
        id="Vector"
        d="M7.33516 14.008V12.5797C6.71271 12.4393 6.18271 12.1686 5.74516 11.7673C5.3076 11.3661 4.99193 10.8098 4.79816 10.0985L6.22132 9.53051C6.39288 10.089 6.63366 10.4952 6.94366 10.7493C7.25366 11.0035 7.65371 11.1305 8.14382 11.1305C8.59716 11.1305 8.96038 11.0405 9.23349 10.8603C9.5066 10.6802 9.64316 10.4046 9.64316 10.0333C9.64316 9.68845 9.51916 9.39534 9.27116 9.15401C9.02327 8.91267 8.45282 8.66256 7.55982 8.40368C6.67382 8.13845 6.04955 7.79723 5.68699 7.38001C5.32443 6.9629 5.14316 6.43623 5.14316 5.80001C5.14316 5.11956 5.3686 4.56779 5.81949 4.14467C6.27049 3.72167 6.77571 3.46356 7.33516 3.37034V1.97534H8.72649V3.37034C9.32938 3.48434 9.81105 3.7164 10.1715 4.06651C10.532 4.41662 10.7936 4.81401 10.9562 5.25868L9.55182 5.85284C9.43027 5.54317 9.24016 5.29356 8.98149 5.10401C8.72282 4.91434 8.38899 4.81951 7.97999 4.81951C7.55177 4.81951 7.22893 4.90762 7.01149 5.08384C6.79393 5.26006 6.68516 5.48934 6.68516 5.77167C6.68516 6.07779 6.80882 6.32695 7.05616 6.51918C7.30349 6.71151 7.83416 6.92229 8.64816 7.15151C9.47327 7.39184 10.1052 7.74901 10.5438 8.22301C10.9825 8.69701 11.1963 9.28934 11.1852 10C11.174 10.7807 10.9358 11.3846 10.4705 11.8118C10.0052 12.239 9.42382 12.506 8.72649 12.613V14.008H7.33516Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
